export const toastMessage = (toast, status, message, description) => {
  toast({
    title: message,
    description: description,
    status: status,
    duration: status === "success" ? 2000 : 3000,
    isClosable: true,
  })
}